import { schoolYearsData } from './schoolYearsData.js';
import { appointedYears } from './appointedYearsData.js';
import { equateYears } from './equateYearsData.js';

export const labTechData = [
    {
        id: 'hello-there',
        jobTitle: 'lab-tech',
        components: [
            {
                type: "Title",
                content: "Lab Tech",
            },
            {
                type: "Sub Title",
                content: "There are <strong>two factors</strong> that influence your pay:"
            },
            {
                type: "Content Box",
                title: "Working Experience",
                textAlign: "left",
                icon: "teach-exp",
                content: [
                    {
                        content: '"Salary Steps"',
                    },
                ]
            },
            {
                type: "Content Box",
                title: "Length of Employment",
                textAlign: "left",
                icon: "employment-length",
                content: [
                    {
                        content: '"Longevity"',
                    },
                ]
            },
            {
                type: "Content",
                content: "We're going to check each one for errors."
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Get started", 
                        linkId: "appointed-under-a-different-title",
                    }
                ]
            }
        ]
    },
    {
        id: 'appointed-under-a-different-title',
        jobTitle: 'lab-tech',
        background: [
            {
                color: "#F4F9E8",
            }
        ],
        components: [
            {
                type: "Title",
                content: "Before we begin...",
                underline: true
            },
            {
                type: "Sub Title",
                content: "Have you ever been appointed under a different title by the NYC DOE?",
            },
            {
                type: 'Question',
                content: [
                    {
                        question: "Yes",
                        answerId: "to-which-title-were-you-appointed",
                    },
                    {   
                        question: "No",
                        answerId: "teaching-experience"
                    }
                ]
            }
        ]
    },
    {
        id: 'to-which-title-were-you-appointed',
        jobTitle: 'lab-tech',
        background: [
            {
                color: "#F4F9E8",
            }
        ],
        components: [
            {
                type: "Sub Title",
                content: "To which title were you appointed?",
            },
            {
                type: 'Question',
                content: [
                    {
                        question: "Paraprofessional",
                        answerId: "got-it"
                    },
                    {   
                        question: "Something Else",
                        answerId: "call-a-uft-salary-specialist"
                    }
                ]
            }
        ]
    },
    {
        id: 'got-it',
        jobTitle: 'lab-tech',
        background: [
            {
                color: "#F4F9E8",
            }
        ],
        components: [
            {
                type: "Title",
                content: "Got it!",
                underline: true
            },
            {
                type: "Sub Title",
                content: "Your experience as a paraprofessional does not impact your current role. You may continue checking your salary.",
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: "teaching-experience",
                    }
                ]
            }
        ]
    },
    {
        id: "call-a-uft-salary-specialist",
        jobTitle: 'lab-tech',
        background: [
            {
                color: "#F4F9E8",
            }
        ],
        components: [
            {
                type: "Title",
                content: "This tool may not work for you.",
                underline: true
            },
            {
                type: "Content",
                content: "Please call a UFT Salary Specialist at <a href='tel:212-331-6311' class='text-link'>212-331-6311</a> if you would like to check your salary for errors."
            }
        ]
    },
    {
        id: "teaching-experience",
        jobTitle: 'lab-tech',
        stepNumber: 2,
        components: [
            {
                type: "Image",
                content: require("../../src/imgs/teaching-exp-green.png"),
                width: "64px"
            },
            {
                type: "Title",
                content: "Working Experience"
            },
            {
                type: "Content",
                content: "As a Lab Tech, you earn salary increases for each year of satisfactory service you complete, up to a maximum of 6.5 years (not including longevities). The NYC DOE tracks your progress with salary steps, and sometimes errors occur. Let’s make sure you’re getting credit for all your hard work."
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Watch your step",
                        linkId: "when-were-you-appointed-by-the-doe-in-your-current-title",
                    }
                ]
            }
        ]
    },
    {
        id: "when-were-you-appointed-by-the-doe-in-your-current-title",
        jobTitle: 'lab-tech',
        stepNumber: 2,
        components: [
            {
                type: "Sub Title",
                content: "When were you appointed as a Lab Tech by the NYC DOE?"
            },
            ...schoolYearsData,
            {
                type: "Checkbox",
                id: "appointed-after-school-year",
                content:[
                    {
                        label: "I was appointed <em>after</em> the school year began",
                        value: "checked",
                    }
                ]
            },
            {   
                type: 'Button', 
                precedence: "checkbox", 
                content: [
                    {
                        label: "Continue",
                        linkId: [
                            "maxed-payroll-portal",
                            "payroll-portal",
                        ],
                        hidden: true,
                        variableId: "appointed-date"
                    },
                    {
                        label: "Continue",
                        linkId: "when-were-you-appointed",
                        hidden: true,
                        variableId: "appointed-after-school-year"
                    }
                ]
            },
        ]
    },
    {
        id: "when-were-you-appointed",
        jobTitle: 'lab-tech',
        stepNumber: 2,
        components: [
            {
                type: "Sub Title",
                content: "When were you appointed?"
            },
            {
                type: "Dropdown",
                id: "appointed-month",
                content: [
                    {
                        label: "Month",
                        value: "",
                        disabled: true
                    },
                    {
                        label: "January",
                        value: "01"
                    },
                    {
                        label: "February",
                        value: "02"
                    },
                    {
                        label: "March",
                        value: "03"
                    },
                    {
                        label: "April",
                        value: "04"
                    },
                    {
                        label: "May",
                        value: "05"
                    },
                    {
                        label: "June",
                        value: "06"
                    },
                    {
                        label: "July",
                        value: "07"
                    },
                    {
                        label: "August",
                        value: "08"
                    },
                    {
                        label: "September",
                        value: "09"
                    },
                    {
                        label: "October",
                        value: "10"
                    },
                    {
                        label: "November",
                        value: "11"
                    },
                    {
                        label: "December",
                        value: "12"
                    }
                ]
            },
            {
                type: "Dropdown",
                id: "appointed-day",
                content: [
                    {
                        label: "Day",
                        value: "",
                        disabled: true
                    },
                    {
                        label: "1",
                        value: "1"
                    },
                    {
                        label: "2",
                        value: "2"
                    },
                    {
                        label: "3",
                        value: "3"
                    },
                    {
                        label: "4",
                        value: "4"
                    },
                    {
                        label: "5",
                        value: "5"
                    },
                    {
                        label: "6",
                        value: "6"
                    },
                    {
                        label: "7",
                        value: "7"
                    },
                    {
                        label: "8",
                        value: "8"
                    },
                    {
                        label: "9",
                        value: "9"
                    },
                    {
                        label: "10",
                        value: "10"
                    },
                    {
                        label: "11",
                        value: "11"
                    },
                    {
                        label: "12",
                        value: "12"
                    },
                    {
                        label: "13",
                        value: "13"
                    },
                    {
                        label: "14",
                        value: "14"
                    },
                    {
                        label: "15",
                        value: "15"
                    },
                    {
                        label: "16",
                        value: "16"
                    },
                    {
                        label: "17",
                        value: "17"
                    },
                    {
                        label: "18",
                        value: "18"
                    },
                    {
                        label: "19",
                        value: "19"
                    },
                    {
                        label: "20",
                        value: "20"
                    },
                    {
                        label: "21",
                        value: "21"
                    },
                    {
                        label: "22",
                        value: "22"
                    },
                    {
                        label: "23",
                        value: "23"
                    },
                    {
                        label: "24",
                        value: "24"
                    },
                    {
                        label: "25",
                        value: "25"
                    },
                    {
                        label: "26",
                        value: "26"
                    },
                    {
                        label: "27",
                        value: "27"
                    },
                    {
                        label: "28",
                        value: "28"
                    },
                    {
                        label: "29",
                        value: "29"
                    },
                    {
                        label: "30",
                        value: "30"
                    },
                    {
                        label: "31",
                        value: "31"
                    },
                ]
            },
            ...appointedYears,
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: [
                            "maxed-payroll-portal",
                            "payroll-portal",
                        ],
                        hidden: true,
                        variableId: [
                            "appointed-month",
                            "appointed-day",
                            "appointed-year"
                        ]
                    }
                ]
            },
        ]
    },
    {
        id: "payroll-portal",
        jobTitle: 'lab-tech',
        stepNumber: 2,
        components: [
            {
                type: "Sub Title",
                content: "In the NYC DOE payroll portal, are these the first two characters of your salary code?"
            },
            {
                type: 'Modal',
                label: 'Where do I find this?',
                title: "Where to find your salary code:",
                content: [
                    {
                        type: "Content",
                        content: "1. Log into the <a href='https://payrollportal.nycboe.net' class='text-link' target='_blank'>NYC DOE payroll portal</a>",
                        textAlign: "left",
                    },
                    {
                        type: "Content",
                        content: "2. Under Employee Self Service, select Payroll Register",
                        textAlign: "left",
                    },
                    {
                        type: "Image",
                        image: require("../../src/imgs/payroll-portal-1.png"),
                        width: "100%"
                    },
                    {
                        type: "Content",
                        content: "3. Select the tab labeled Salary Info",
                        textAlign: "left",
                    },
                    {
                        type: "Image",
                        image: require("../../src/imgs/payroll-portal-2.png"),
                        width: "100%"
                    },
                    {
                        type: "Content",
                        content: "4. Your salary step is represented by the third and fourth characters of your salary code",
                        textAlign: "left",
                    },
                    {
                        type: "Image",
                        image: require("../../src/imgs/payroll-portal-asst.png"),
                        width: "100%"
                    }
                ]
            },
            {
                type: "Pay Code Stub",
                paycode: "",
            },
            {   
                type: 'Question', 
                id: "step-2-status",
                content: [
                    {
                        question: "Yes",
                        answerId: "estimated-salary-step-schedule",
                    },
                    {   
                        question: "No",
                        value: "fail",
                        answerId: "you-may-have-a-salary-step-error",
                    }
                ]
            }
        ]
    },
    {
        id: "maxed-payroll-portal",
        jobTitle: 'lab-tech',
        stepNumber: 2,
        components: [
            {
                type: "Sub Title",
                content: "Does this code appear in the NYC DOE payroll portal?"
            },
            {
                type: 'Modal',
                label: 'Where do I find this?',
                title: "Where to find your salary code:",
                content: [
                    {
                        type: "Content",
                        content: "1. Log into the <a href='https://payrollportal.nycboe.net' class='text-link' target='_blank'>NYC DOE payroll portal</a>",
                        textAlign: "left",
                    },
                    {
                        type: "Content",
                        content: "2. Under Employee Self Service, select Payroll Register",
                        textAlign: "left",
                    },
                    {
                        type: "Image",
                        image: require("../../src/imgs/payroll-portal-1.png"),
                        width: "100%"
                    },
                    {
                        type: "Content",
                        content: "3. Select the tab labeled Salary Info",
                        textAlign: "left",
                    },
                    {
                        type: "Image",
                        image: require("../../src/imgs/payroll-portal-2.png"),
                        width: "100%"
                    },
                    {
                        type: "Content",
                        content: "4. Your salary step is represented by the third and fourth characters of your salary code",
                        textAlign: "left",
                    },
                    {
                        type: "Image",
                        image: require("../../src/imgs/payroll-portal-asst.png"),
                        width: "100%"
                    }
                ]
            },
            {
                type: "Pay Code Stub",
                paycode: "",
            },
            {   
                type: 'Question', 
                id: "step-2-status",
                content: [
                    {
                        question: "Yes",
                        answerId: "way-to-go",
                    },
                    {   
                        question: "No",
                        value: "fail",
                        answerId: "you-may-have-a-salary-step-error",
                    }
                ]
            }
        ]
    },
    {
        id: "estimated-salary-step-schedule",
        jobTitle: 'lab-tech',
        stepNumber: 2,
        components: [
            {
                type: "Sub Title",
                content: "Here’s your forecasted salary step dates."
            },
            {
                type: "Modal",
                label: 'How accurate is this?',
                title: "How accurate is this?",
                content: [
                    {
                        type: "Content",
                        content: "This estimate of your salary step schedule assumes you will remain on NYC DOE payroll during this entire period and will have satisfactory evaluations each year.",
                        textAlign: "left",
                    },
                    {
                        type: "Content",
                        content: "Events that can affect your salary step progress:",
                        listItems:[
                            "Unpaid leaves*",
                            "Overall unsatisfactory or ineffective rating"
                        ],
                        textAlign: "left",
                    },
                    {
                        type: "Content",
                        content: "*You must reapply for salary step credit when returning to NYC DOE payroll",
                        textAlign: "left",
                        textSize: "small"
                    }
                ]
            },
            {
                type: 'Salary Schedule'
            },
            {   
                type: 'Button',
                id: "step-2-status",
                content: [
                    {
                        label: "Continue",
                        value: "pass",
                        linkId: "great-teaching-experience"
                    }
                ]
            }
        ]
    },
    {
        id: "you-may-have-a-salary-step-error",
        jobTitle: 'lab-tech',
        stepNumber: 2,
        components: [
            {
                type: "Title",
                content: "What to do about a salary step error:"
            },
            {
                type: "Content",
                content: "After your salary checkup is complete, report the error through <a href='https://hub.uft.org/uftselfservice/s/salary-inquiry-form' target='_blank' class='text-link'>this online form</a> or call a UFT Salary Specialist at <a href='tel:212-331-6311' class='text-link'>212-331-6311</a>. We will include this information again on the final review.",
                textAlign: "center"
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: "length-of-employment"
                    }
                ]
            }
        ]
    },
    {
        id: "salary-step-error",
        jobTitle: 'lab-tech',
        stepNumber: 2,
        components: [
            {
                type: "Title",
                content: "You likely have a salary step error."
            },
            {
                type: "Content",
                content: "After you resubmit a salary step placement application to the NYC DOE, this problem should be resolved. If you are still within 6 months of returning to work, you may also receive retroactive pay for the error."
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: "length-of-employment"
                    }
                ]
            }
        ]
    },
    {
        id: "way-to-go",
        jobTitle: 'lab-tech',
        background: [
            {
                image: require("../../src/imgs/confetti-green.gif"),
                size: "480px",
                repeat: "no-repeat",
                position: "top center"
            }
        ],
        stepNumber: 2,
        components: [
            {
                type: "Title",
                content: "Way to Go!",
                underline: true
            },
            {
                type: "Title",
                content: "You've reached the highest salary step."
            },
            {
                type: "Sub Title",
                content: "It sounds like you are getting paid correctly for your working experience."
            },
            {   
                type: 'Button',
                id: "step-2-status",
                content: [
                    {
                        label: "Continue",
                        linkId: "length-of-employment",
                        value: "pass"
                    }
                ]
            }
        ]
    },
    {
        id: "great-teaching-experience",
        jobTitle: 'lab-tech',
        background: [
            {
                image: require("../../src/imgs/confetti-green.gif"),
                size: "480px",
                repeat: "no-repeat",
                position: "top center"
            }
        ],
        stepNumber: 2,
        components: [
            {
                type: "Title",
                content: "Great!",
                underline: true
            },
            {
                type: "Sub Title",
                content: " It sounds like you are getting paid correctly for your working experience."
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: "length-of-employment"
                    }
                ]
            }
        ]
    },
    {
        id: "length-of-employment",
        jobTitle: 'lab-tech',
        stepNumber: 3,
        components: [
            {
                type: "Image",
                content: require("../../src/imgs/length-of-employment-green.png"),
                alt: "Length of Emplpoyment Icon",
                width: "65px"
            },
            {
                type: "Title",
                content: "Length of Employment"
            },
            {
                type: "Content",
                content: "As a Lab Tech, you get additional salary increases on seven key work anniversaries: 5, 10, 13, 15, 18, 20 and 22 years. These increases, called longevities, add thousands to your salary. Let’s see when you can celebrate."
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Remember your anniversaries",
                        linkId: "correct-apponted-date"
                    }
                ]
            }
        ]
    },
    {
        id: "correct-apponted-date",
        jobTitle: 'lab-tech',
        stepNumber: 3,
        components: [
            {
                type: "Appointed Date",
                content: "We estimate your appointed date is",
            },
            {
                type: "Sub Title",
                content: "Is this correct?"
            },
            {   
                type: 'Question',
                content: [
                    {
                        question: "Yes",
                        answerId: "have-you-ever-been-off-doe-payroll-for-more-than-30-days",
                    },
                    {   
                        question: "No",
                        answerId: "when-were-you-appointed-by-the-doe-in-your-current-title-incorrect",
                    }
                ]
            }
        ]
    },
    {
        id: "have-you-ever-been-off-doe-payroll-for-more-than-30-days",
        jobTitle: 'lab-tech',
        stepNumber: 3,
        components: [
            {
                type: "Sub Title",
                content: "Have you ever been off NYC DOE payroll for more than 30 days?"
            },
            {   
                type: 'Question',
                id: "step-3-status",
                content: [
                    {
                        question: "Yes",
                        value: "fail",
                        answerId: "off-doe-payroll-for-more-than-30-days"
                    },
                    {   
                        question: "No",
                        answerId: [
                            "no-longevity-increase",
                            "highest-longevity",
                            "longevity-increase"
                        ],
                        variableId: "appointed-date"
                    }
                ]
            }
        ]
    },
    {
        id: "off-doe-payroll-for-more-than-30-days",
        jobTitle: 'lab-tech',
        stepNumber: 3,
        components: [
            {
                type: "Sub Title",
                content: "Being off NYC DOE payroll for more than 30 days may impact your longevity schedule."
            },
            {
                type: "Content",
                content: "We recommend that you call a UFT Salary Specialist at <a href='tel:212-331-6311' class='text-link'>212-331-6311</a> to confirm your information."
            },
            {   
                type: 'Button',
                content: [
                    {
                        label: "Continue to Final Review",
                        linkStyle: true,
                        linkId: "final-review"
                    }
                ]
            }
        ]
    },
    {
        id: "when-were-you-appointed-by-the-doe-in-your-current-title-incorrect",
        jobTitle: 'lab-tech',
        stepNumber: 3,
        components: [
            {
                type: "Sub Title",
                content: "When were you appointed by the NYC DOE in your current title?"
            },
            ...schoolYearsData,
            {
                type: "Checkbox",
                id: "appointed-after-school-year",
                content:[
                    {
                        label: "I was appointed <em>after</em> the school year began",
                        value: "checked",
                    }
                ]
            },
            {   
                type: 'Button', 
                precedence: "checkbox", 
                content: [
                    {
                        label: "Continue",
                        linkId: "have-you-ever-been-off-doe-payroll-for-more-than-30-days",
                        hidden: true,
                        variableId: "appointed-date"
                    },
                    {
                        label: "Continue",
                        linkId: "when-were-you-appointed-longevity",
                        hidden: true,
                        variableId: "appointed-after-school-year"
                    }
                ]
            },
        ]
    },
    {
        id: "when-were-you-appointed-longevity",
        jobTitle: 'lab-tech',
        stepNumber: 3,
        components: [
            {
                type: "Sub Title",
                content: "When were you appointed?"
            },
            {
                type: "Dropdown",
                id: "appointed-month",
                content: [
                    {
                        label: "Month",
                        value: "",
                        disabled: true
                    },
                    {
                        label: "January",
                        value: "01"
                    },
                    {
                        label: "February",
                        value: "02"
                    },
                    {
                        label: "March",
                        value: "03"
                    },
                    {
                        label: "April",
                        value: "04"
                    },
                    {
                        label: "May",
                        value: "05"
                    },
                    {
                        label: "June",
                        value: "06"
                    },
                    {
                        label: "July",
                        value: "07"
                    },
                    {
                        label: "August",
                        value: "08"
                    },
                    {
                        label: "September",
                        value: "09"
                    },
                    {
                        label: "October",
                        value: "10"
                    },
                    {
                        label: "November",
                        value: "11"
                    },
                    {
                        label: "December",
                        value: "12"
                    }
                ]
            },
            {
                type: "Dropdown",
                id: "appointed-day",
                content: [
                    {
                        label: "Day",
                        value: "",
                        disabled: true
                    },
                    {
                        label: "1",
                        value: "1"
                    },
                    {
                        label: "2",
                        value: "2"
                    },
                    {
                        label: "3",
                        value: "3"
                    },
                    {
                        label: "4",
                        value: "4"
                    },
                    {
                        label: "5",
                        value: "5"
                    },
                    {
                        label: "6",
                        value: "6"
                    },
                    {
                        label: "7",
                        value: "7"
                    },
                    {
                        label: "8",
                        value: "8"
                    },
                    {
                        label: "9",
                        value: "9"
                    },
                    {
                        label: "10",
                        value: "10"
                    },
                    {
                        label: "11",
                        value: "11"
                    },
                    {
                        label: "12",
                        value: "12"
                    },
                    {
                        label: "13",
                        value: "13"
                    },
                    {
                        label: "14",
                        value: "14"
                    },
                    {
                        label: "15",
                        value: "15"
                    },
                    {
                        label: "16",
                        value: "16"
                    },
                    {
                        label: "17",
                        value: "17"
                    },
                    {
                        label: "18",
                        value: "18"
                    },
                    {
                        label: "19",
                        value: "19"
                    },
                    {
                        label: "20",
                        value: "20"
                    },
                    {
                        label: "21",
                        value: "21"
                    },
                    {
                        label: "22",
                        value: "22"
                    },
                    {
                        label: "23",
                        value: "23"
                    },
                    {
                        label: "24",
                        value: "24"
                    },
                    {
                        label: "25",
                        value: "25"
                    },
                    {
                        label: "26",
                        value: "26"
                    },
                    {
                        label: "27",
                        value: "27"
                    },
                    {
                        label: "28",
                        value: "28"
                    },
                    {
                        label: "29",
                        value: "29"
                    },
                    {
                        label: "30",
                        value: "30"
                    },
                    {
                        label: "31",
                        value: "31"
                    },
                ]
            },
            ...appointedYears,
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: "have-you-ever-been-off-doe-payroll-for-more-than-30-days",
                        hidden: true
                    }
                ]
            },
        ]
    },
    {
        id: "no-longevity-increase",
        jobTitle: 'lab-tech',
        stepNumber: 3,
        components: [
            {
                type: "Title",
                content: "Keep going!",
                underline: true
            },
            {
                type: "Longevity Date"
            },
            {
                type: "Content",
                content: "At that time, the A/B in your salary step code will change to a V/W."
            },
            {   
                type: 'Button', 
                id: "step-3-status",
                content: [
                    {
                        label: "See all of your longevity increases",
                        value: "pass",
                        linkId: "longevity-schedule"
                    }
                ]
            }
        ]
    },
    {
        id: "highest-longevity",
        jobTitle: 'lab-tech',
        background: [
            {
                image: require("../../src/imgs/confetti-green.gif"),
                size: "480px",
                repeat: "no-repeat",
                position: "top center"
            }
        ],
        stepNumber: 3,
        components: [
            {
                type: "Title",
                content: "You are amazing!",
                underline: true
            },
            {
                type: "Longevity Date"
            },
            {
                type: "Content",
                content: "This increase has become part of your base salary and is pensionable."
            },
            {   
                type: 'Button', 
                id: "step-3-status",
                content: [
                    {
                        label: "Go to final review",
                        linkId: "final-review",
                        value: "pass"
                    }
                ]
            }
        ]
    },
    {
        id: "longevity-increase",
        jobTitle: 'lab-tech',
        background: [
            {
                image: require("../../src/imgs/confetti-green.gif"),
                size: "480px",
                repeat: "no-repeat",
                position: "top center"
            }
        ],
        stepNumber: 3,
        components: [
            {
                type: "Title",
                content: "Congrats!",
                underline: true
            },
            {
                type: "Longevity Date"
            },
            {
                type: "Content",
                content: "This increase has become part of your annual salary and is pensionable."
            },
            {   
                type: 'Button', 
                id: "step-3-status",
                content: [
                    {
                        label: "See your next increases",
                        value: "pass",
                        linkId: "longevity-schedule"
                    }
                ]
            }
        ]
    },
    {
        id: "longevity-schedule",
        jobTitle: 'lab-tech',
        stepNumber: 3,
        components: [
            {
                type: "Sub Title",
                content: "Here are your forecasted longevity dates."
            },
            {
                type: 'Modal',
                label: 'When will I see my pay increase?',
                title: "When will my longevity increase show up in my paycheck?",
                content: [
                    {
                        type: "Content",
                        content: "Longevity increases should be reflected in 1&ndash;2 pay periods following your eligibility date and will include any retroactive pay if applicable.",
                        textAlign: "center",
                    }
                ]
            },
            {
                type: "Longevity Schedule"
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: "final-review",
                    }
                ]
            }
        ]
    },
    {
        id: "final-review",
        jobTitle: 'lab-tech',
        background: [
            {
                color: "#17724D",
            }
        ],
        stepNumber: 4,
        components: [
            {
                type: "Title",
                content: "Final Review",
            },
            {
                type: "Sub Title",
                content: "We checked each aspect of your pay for errors."
            },
            {
                type: "Pay Code Stub",
                paycode: "",
            },
            {
                type: "Content Box",
                title: "Working Experience",
                textAlign: "left",
                errorCheck: "step-2-status",
                content: [
                    {
                        content: 'Salary Steps',
                    },
                ],
                modal:[
                    {
                        label: 'Take action',
                        title: "Recommended Action",
                        content: [
                            {
                                type: "Alert",
                                level: "warning",
                                alert: "Salary Step Error"
                            },
                            {
                                type: "Content",
                                content: "Based on the information you provided, we believe you should be on salary step:",
                                textAlign: "center",
                            },
                            {
                                type: "Pay Code",
                                codeType: "salary step"
                            },
                            {
                                type: "Content",
                                content: "Most salary step errors are caused by one of two things: forgetting to resubmit a salary step application after being off NYC DOE payroll for more than 30 days, or failing to submit information about qualifying work experience when initially appointed.",
                                textAlign: "center",
                            },
                            {
                                type: "External Link",
                                label: "Report Error Online",
                                link: "https://hub.uft.org/uftselfservice/s/salary-inquiry-form",
                                isButtonStyle: true
                            },
                            {
                                type: "External Link",
                                label: "Call a UFT Salary Specialist",
                                link: "tel:212-331-6311",
                                isButtonStyle: true
                            },
                            {
                                type: "External Link",
                                label: "Resubmit a Salary Step Application",
                                link: "https://nycenet.edu/salapps",
                                isButtonStyle: true
                            }
                        ]
                    }
                ]
            },
            {
                type: "Content Box",
                title: "Length of Employment",
                textAlign: "left",
                errorCheck: "step-3-status",
                content: [
                    {
                        content: 'Longevity',
                    },
                ],
                modal:[
                    {
                        label: 'Take action',
                        title: "Recommended Action",
                        content: [
                            {
                                type: "Alert",
                                level: "warning",
                                alert: "Longevity Issue"
                            },
                            {
                                type: "Content",
                                content: "Because you were off NYC DOE payroll for 30 or more days, we recommend that you call a UFT Salary Specialist to ensure your longevity schedule is correct.",
                                textAlign: "center",
                            },
                            {
                                type: "External Link",
                                label: "Call a UFT Salary Specialist",
                                link: "tel:212-331-6311",
                                isButtonStyle: true
                            }
                        ]
                    }
                ]
            },
            {
                type: "Salary Schedule Codes",
                title: "Your place on the NYC DOE salary schedule:",
                content: [
                    {
                        type: "Content",
                        content: "Be sure to review the salary schedule for the current year. The date is listed at the top."
                    },
                    {
                        type: "External Link",
                        label: "Open Lab Tech Salary Schedule",
                        link: "https://www.uft.org/your-rights/salary/doe-and-city-salary-schedules/lab-spec-tech-salary-schedule"
                    }
                ]
            },
            {
                type: "Salary Schedule",
                title: "Forecasted salary step & longevity dates:",
                longevity: true
            }
        ]
    }
]